import axios from 'axios'
import MockAdapter from 'axios-mock-adapter'

import { MockDB } from './model/mockDB.model'

const interceptors = new MockAdapter(axios, { onNoMatch: 'passthrough', delayResponse: 50 })

function initInterceptor(mockDB: MockDB) {
  Object.values(mockDB).forEach(
    (mockEle) => mockEle.addInterceptor && mockEle.addInterceptor(interceptors),
  )
}

const MockInterceptor = {
  interceptors,
  initInterceptor,
}

export default MockInterceptor
